import { SalesReturnStatusEnum } from "./return-status-enum";

export const salesReturnStatusColors = Object.freeze({
  [SalesReturnStatusEnum.NONE]: "default",
  [SalesReturnStatusEnum.PARTIALLY_RETURNED]: "warning",
  [SalesReturnStatusEnum.FULLY_RETURNED]: "success",
});
